import { render } from "./menuStartWidgets.vue?vue&type=template&id=4d0604c4&scoped=true"
import script from "./menuStartWidgets.vue?vue&type=script&lang=js"
export * from "./menuStartWidgets.vue?vue&type=script&lang=js"

import "./menuStartWidgets.vue?vue&type=style&index=0&id=4d0604c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d0604c4"

export default script